module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMjAgNTEyIj48cGF0aCBkPSJNMTkyIDQxNmMwIDE3LjctMTQuMyAzMi0zMiAzMnMtMzItMTQuMy0zMi0zMiAxNC4zLTMyIDMyLTMyIDMyIDE0LjMgMzIgMzJ6TTMyMCA0OHY0MTZjMCAyNi41LTIxLjUgNDgtNDggNDhINDhjLTI2LjUgMC00OC0yMS41LTQ4LTQ4VjQ4QzAgMjEuNSAyMS41IDAgNDggMGgyMjRjMjYuNSAwIDQ4IDIxLjUgNDggNDh6bS0zMiAwYzAtOC44LTcuMi0xNi0xNi0xNkg0OGMtOC44IDAtMTYgNy4yLTE2IDE2djQxNmMwIDguOCA3LjIgMTYgMTYgMTZoMjI0YzguOCAwIDE2LTcuMiAxNi0xNlY0OHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/pages/mobile.svg
// module id = 124
// module chunks = 35783957827783 170384593892729